import React from 'react';
import { ShoppingCart } from 'lucide-react'; // Or substitute with your standard SVG cart

export default function QuickShopHeader() {
  return (
    <div style={{ textAlign: "center", marginBottom: 48 }}>
      {/* 🔮 inject keyframe animations directly into a style tag for inline compatibility */}
      <style>{`
        @keyframes cartVibrate {
          0% { transform: translate(0, 0) rotate(0deg); }
          20% { transform: translate(-0.5px, 0.5px) rotate(-0.5deg); }
          40% { transform: translate(-0.5px, -0.5px) rotate(0.5deg); }
          60% { transform: translate(0.5px, 0.5px) rotate(0deg); }
          80% { transform: translate(0.5px, -0.5px) rotate(-0.5deg); }
          100% { transform: translate(0, 0) rotate(0deg); }
        }
        @keyframes lineFade {
          0% { opacity: 0.3; transform: scaleX(0.8); }
          50% { opacity: 0.8; transform: scaleX(1.2); }
          100% { opacity: 0.3; transform: scaleX(0.8); }
        }
      `}</style>

      {/* Speeding Shopping Cart Graphic Wrapper */}
      <div style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        marginBottom: 16,
        padding: "0 10px"
      }}>
        {/* Trailing Speed Lines (Left of Cart Badge) */}
        <div style={{ 
          display: "flex", 
          flexDirection: "column", 
          gap: "4px", 
          marginRight: "12px",
          alignItems: "flex-end"
        }}>
          <div style={{ width: 14, height: 2, background: "#eab308", borderRadius: 99, animation: "lineFade 0.6s infinite ease-in-out" }} />
          <div style={{ width: 22, height: 2, background: "#eab308", borderRadius: 99, animation: "lineFade 0.4s infinite ease-in-out" }} />
          <div style={{ width: 10, height: 2, background: "#eab308", borderRadius: 99, animation: "lineFade 0.8s infinite ease-in-out" }} />
        </div>

        {/* Animated Pill Container holding the Cart + Text */}
        <div style={{
        //   background: "#fef9c3",
        //   border: "2px solid #fde047",
          borderRadius: 9999, // Changed from 50% to look like a clean pill badge
          padding: "12px 28px", // Clean internal spacing around text
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(253, 224, 71, 0.2)",
          animation: "cartVibrate 0.3s infinite linear",
          transformOrigin: "bottom center"
        }}>
          {/* 🌟 THIS DIV FLIPS THE LAYOUT TO A SNAPPY ROW */}
          <div style={{ 
            display: "flex", 
            alignItems: "center", 
            gap: "12px", // Puts a nice gap between the icon and your header text
            transform: "rotate(-2deg)" // Subtle speed tilt forward
          }}>
            <ShoppingCart size={26} strokeWidth={2.5} style={{ color: "#854d0e" }} />
            
            <h2 style={{
              fontSize: "26px",
              fontWeight: 800,
              color: "#854d0e", // Matched text color to badge theme for a clean look
              margin: 0, // Reset default margins to prevent visual offsets
              letterSpacing: "-0.5px",
              fontFamily: "system-ui, sans-serif",
              whiteSpace: "nowrap" // Keeps text firmly glued to one line
            }}>
              Quick Shop
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
}